import moment from 'moment'

const calcDate = (kind) => {
  if (kind === 'TODAY') return moment().format('YYYY-MM-DD')
  if (kind === 'YESTERDAY')
    return moment().subtract(1, 'days').format('YYYY-MM-DD')

  return moment().add(1, 'days').format('YYYY-MM-DD')
}

export default calcDate
